import { render, staticRenderFns } from "./BoolField.vue?vue&type=template&id=1d3166c9"
import script from "./BoolField.vue?vue&type=script&lang=ts"
export * from "./BoolField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports